import {
  SPI,
  FormFieldWidget,
  ViewType,
  ModelFieldType,
  FormM2OSelectFieldWidget,
  IQueryPageOption,
  IQueryPageResult,
  Widget
} from '@kunlun/dependencies';
import { fetchPlanList } from './service';
import { Message } from '../../../../constants/message';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    model: [],
    name: 'deliAriesPromotionPlan',
    ttype: ModelFieldType.ManyToOne,
    multi: false
  })
)
export class PlanSelectWidget extends FormM2OSelectFieldWidget {
  protected async loadOptions(param?: IQueryPageOption | undefined) {
    const { condition = '' } = param || {};
    const content = {
      content: [],
      totalPages: 0,
      totalElements: 0,
      size: 0
    } as IQueryPageResult<Record<string, unknown>>;

    const buyerPartnerId = this.formData.buyerPartnerId as string;
    const sellerPartnerId = (this.formData.seller as any).id;
    const bizType= this.formData.bizType as string;

    if (!buyerPartnerId || !sellerPartnerId) {
      return content;
    }

    let regex = /like='%([^%]+)%'/g;
    let matches: any[] = [];
    let match: RegExpExecArray;
    // @ts-ignore
    while ((match = regex.exec(condition as string)) !== null) {
      matches.push(match[1]);
    }

    const res = await fetchPlanList(this.model, {
      buyerPartnerId,
      sellerPartnerId,
      bizType,
      planSearchKey: matches[0]
    });

    content.content = res;

    return content;
  }

  @Widget.Watch('formData.bizType')
  protected async watchBizType(value: string) {
    // 集中收单
    if (value === 'CENTRALIZED_ACQUIRING' || value==='POLICY_PROMOTION') {
      await this.initLoadOptions();
    }
  }

  change(value: any): void {
    super.change(value);
    window.postMessage(Message.ChangeActivityPlan);
  }
}
